import { render, staticRenderFns } from "./DynamicLayout.vue?vue&type=template&id=396df7f9"
import script from "./DynamicLayout.vue?vue&type=script&lang=js"
export * from "./DynamicLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('396df7f9')) {
      api.createRecord('396df7f9', component.options)
    } else {
      api.reload('396df7f9', component.options)
    }
    module.hot.accept("./DynamicLayout.vue?vue&type=template&id=396df7f9", function () {
      api.rerender('396df7f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layouts/DynamicLayout.vue"
export default component.exports